import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  path: z.string().optional(),
});

export const Route = createFileRoute("/capture/")({
  staticData: {
    title: "Capture",
  },
  validateSearch: searchSchema,
});
